const productVariants = null;

const ENV = 'prod'

import { initFittingRoom } from 'https://unpkg.com/@thefittingroom/shop-ui@3.0.0-alpha-4/dist/esm/index.min.js'

const brandID = 5

// All variants should contain the same brand_style_id in SKU field
const getBrandStyleId = () => {
  const brandStyleId = tfrProduct.variants?.[0].sku

  if (!brandStyleId) throw new Error('No style found')

  return brandStyleId
}

window.addEventListener('load', async (e) => {
  const brandStyleId = getBrandStyleId()
  const config = {
    shopId: brandID,
    modalDivId: 'thefittingroom-modal',
    sizeRecMainDivId: 'tfr-size-recommendation-main',
    env: ENV
  }
  const tfr = await initFittingRoom(config)

  const isPublished = await tfr.checkIfPublished(brandStyleId)
  if (!isPublished) return
  
  document.querySelector('#tfr-size-recommendation-main').style.display = "flex"

  // Has a fallback to use brand_style_id after variant specific sku
  tfr.setSku(brandStyleId)
})
